/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_65e93c3b{margin:10px 0}.exampleLabel_65e93c3b{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_65e93c3b";
export const exampleLabel = "exampleLabel_65e93c3b";